import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Mousewheel, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/mousewheel';
import 'swiper/css/navigation';
import styles from './Css/SliderHomepage.module.css';
import { X, } from 'lucide-react';
import useAuthStore from '../../store/authStore';
import { useNavigate } from 'react-router-dom';
import { useContinueListening, useDeleteContinueListening } from '../../hooks/useContinueListening';

const ImageSliderr = () => {
  const { isAuthenticated } = useAuthStore();
  const navigate = useNavigate();
  const { continueListeningData, isLoading, } = useContinueListening();
  const { deleteContinueListening } = useDeleteContinueListening();
  console.log('continueListeningData:', continueListeningData);
  

  if (!isAuthenticated || isLoading || !continueListeningData?.continueListening?.length) {
    return null;
  }

  const handleItemClick = (item) => {
  const mediaDetails = item.mediaDetails;
  
  switch (item.itemType) {
    case 'ebook':
      // Check if series_id exists and is not null
      if (mediaDetails.series_id) {
        navigate(`/book-details/${mediaDetails.slug}`);
      } else {
        navigate(`/book-detail/${mediaDetails.slug}`);
      }
      break;
    case 'audio':
      navigate(`/audio-play/${mediaDetails.slug}`);
      break;
    case 'video':
      navigate(`/video/${mediaDetails.slug}`);
      break;
    case 'short':
      navigate(`/shorts/${mediaDetails.slug}`);
      break;
    default:
      console.error('Unknown item type:', item.itemType);
  }
};

  const handleDelete = (e, item) => {
    e.stopPropagation(); // Prevent triggering the parent click event
    deleteContinueListening(item.continueListeningId);
  };

  

  const getImageUrl = (item) => {
    const mediaDetails = item.mediaDetails;
    const isMobile = window.innerWidth <= 768;
    
    switch (item.itemType) {
      case 'audio':
        return isMobile ? mediaDetails.mobile_image_url : mediaDetails.computer_image_url;
      case 'video':
        return isMobile ? mediaDetails.mobile_image_url : mediaDetails.computer_image_url;
      case 'ebook':
        return isMobile ? mediaDetails.cover_image_url_for_mbl : mediaDetails.cover_image_url_for_computer;
      case 'short':
        return mediaDetails.thumbnail_url;
      default:
        return '';
    }
  };

  return (
    <div className={styles.outerDiv}>
      <h2 className={styles.header}>Continue <span className={styles.headerSecond}>Listening/Reading</span> </h2>
      <Swiper
        spaceBetween={20}
        slidesPerView={5}
        navigation
        pagination={{ clickable: true }}
        freeMode={{
    enabled: true,
    momentum: true,
    momentumRatio: 0.8,
    momentumVelocityRatio: 0.8,
    minimumVelocity: 0.02
  }}
  modules={[Navigation, Mousewheel, FreeMode]}
  mousewheel={{
    forceToAxis: true,
    sensitivity: 1.5,
    releaseOnEdges: true
  }}
  speed={600}
  resistance={false}
  resistanceRatio={0}
        breakpoints={{
          320: {
            slidesPerView: 3, // Show 3 slides on smaller screens
            spaceBetween: 8,
          },
          425: {
            slidesPerView: 3.2, // Show 3 slides on medium mobile
            spaceBetween: 8,
          },
          480: {
            slidesPerView: 3, // Show 3 slides on larger mobile
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 7,
            spaceBetween: 12,
          },
          1440: {
            slidesPerView: 7,
            spaceBetween: 12,
          },
        }}
      >
        {continueListeningData.continueListening.map((item) => (
          <SwiperSlide key={item.continueListeningId}>
            <div
              className={styles.slide}
              onClick={() => handleItemClick(item)}
            >
              <img src={getImageUrl(item)} alt={item.mediaDetails.title} />
              
              {/* Delete icon */}
              <div className={styles.deleteIcon} onClick={(e) => handleDelete(e, item)}>
                <X size={window.innerWidth <= 425 ? 16 : 18} color="white" />
              </div>
              
              {/* Media type icon */}
           
              
              
              {/* Progress bar */}
              {item.progress && (
                <div className={styles.progressBarContainer}>
                  <div 
                    className={styles.progressBar} 
                    style={{ width: `${item.progress}%` }}
                  />
                </div>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImageSliderr;